"use client";

import { Skeleton } from "@/components/atoms";
import { Suspense } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./media-gallery.module.css";

import Video from "@/components/atoms/Video";
import ZoomImage from "@/components/atoms/ZoomImage/ZoomImage";
import clsx from "clsx";

const SwiperGallery = ({
  media,
  className,
}: {
  media:
    | {
        href: string;
        alt: string;
        type: string;
      }[]
    | undefined;
  className?: string;
}) => {
  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      scrollbar={{ draggable: true }}
      navigation
      pagination
      className={clsx(className, styles.swiper)}
    >
      {media?.map((image, i) => (
        <SwiperSlide className={styles.slide} key={`${image.href}-${i}`}>
          <div className={styles.imageContainer}>
            {image.type === "image" ? (
              <>
                <ZoomImage
                  src={image?.href}
                  alt={image?.alt}
                  fill
                  className={styles["image-swiper"]}
                  sizes={`(max-width: 1024px) 100vw, (max-width: 2560px) 60vw`}
                  loading={"eager"}
                  priority
                />
                <Skeleton height="100%" />
              </>
            ) : (
              <div className={styles.video}>
                <Suspense fallback={<Skeleton height="100%" />}>
                  <Video
                    url={image?.href}
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                  />
                </Suspense>
              </div>
            )}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
export default SwiperGallery;
